import { fetchFromApi } from "./api";

export async function fetchTeams() {
  const url = "/teams";
  const response = await fetchFromApi(url);
  const data = await response.json();
  sessionStorage.setItem('teamscache', JSON.stringify(data));
  return data;
}